import { render, staticRenderFns } from "./apprPass.vue?vue&type=template&id=c64c2a3e"
import script from "./apprPass.vue?vue&type=script&lang=js"
export * from "./apprPass.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c64c2a3e')) {
      api.createRecord('c64c2a3e', component.options)
    } else {
      api.reload('c64c2a3e', component.options)
    }
    module.hot.accept("./apprPass.vue?vue&type=template&id=c64c2a3e", function () {
      api.rerender('c64c2a3e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sys/appr/doc/apprPass.vue"
export default component.exports